<template>
    <div id="checkout-update-staff-popup" v-if="popupUpdateStaffConfig.item_info">
        <vs-popup class="checkout-update-staff-popup" title="Update Staff" :active.sync="popupUpdateStaffConfig.isOpen">
            <div class="flex p-6 w-full" style="position: absolute; top: 0; left: 0">
                <div class="con-input-search vs-table--search m-0 w-full" style="max-width: unset">
                    <input type="text" class="input-search vs-table--search-input rounded-item border-custom py-3 text-sm w-full" @input="searchStaff" placeholder="Search staff...">
                    <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                </div>

                <div class="pl-4 flex">
                    <feather-icon
                        icon="GridIcon"
                        @click="currentItemView='staff-grid'"
                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                        :svgClasses="{'text-primary stroke-current': currentItemView == 'staff-grid'}"
                    />
                    <feather-icon
                        icon="ListIcon"
                        @click="currentItemView='staff-list'"
                        class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                        :svgClasses="{'text-primary stroke-current': currentItemView == 'staff-list'}"
                    />
                </div>
            </div>

            <div v-if="staffListWithSearch.length > 0" style="max-height: calc(100vh - 270px); overflow-y: auto; margin-top: 70px">
                <vs-row vs-w="12" v-if="currentItemView == 'staff-grid'">
                    <vs-col class="popup-staff-col" v-for="(staff, index) in staffListWithSearch" :key="index" @click.native="selectStaff(staff)">
                        <my-staff-item type="grid" class="m-2" :staffData="staff" :isSelected="getSelectedStaffIndex(staff) == -1 ? false : true" :key="index + '' + item_key"></my-staff-item>
                    </vs-col>
                </vs-row>

                <vs-row vs-w="12" v-if="currentItemView == 'staff-list'" class="border-bottom-custom">
                    <vs-col vs-w="12" v-for="(staff, index) in staffListWithSearch" :key="index" @click.native="selectStaff(staff)">
                        <my-staff-item type="list" :staffData="staff" :isSelected="getSelectedStaffIndex(staff) == -1 ? false : true" :key="index + '' + item_key"></my-staff-item>
                    </vs-col>
                </vs-row>
            </div>
            <div v-else class="flex justify-center" style="margin-top: 85px">No data available</div>

            <div class="flex-center mt-6">
                <vs-button style="min-width: 150px !important;" @click="updateStaff">Save</vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    name: 'popup-update-staff',
    props: {
        popupUpdateStaffConfig: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            search: '',
            item_key: 0,
            currentItemView: 'staff-grid',
            selectedStaff: []
        }
    },
    watch: {
        popupUpdateStaffConfig: {
            immediate: true,
            deep: true,
            handler() {
                this.initData();
            }
        } 
    },
    methods: {
        initData() {
            if(this.popupUpdateStaffConfig && this.popupUpdateStaffConfig.item_info) {
                this.selectedStaff = [];
                if(this.popupUpdateStaffConfig.item_info.staffs && this.popupUpdateStaffConfig.item_info.staffs.length > 0) {
                    this.selectedStaff = JSON.parse(JSON.stringify(this.popupUpdateStaffConfig.item_info.staffs));
                }
            }
            this.search = '';
            this.currentItemView = 'staff-grid';
        },
        searchStaff({target}) {
            this.search = target.value; 
        },
        getSelectedStaffIndex(staff) {
            if(staff && this.selectedStaff && this.selectedStaff.length > 0) {
                for(let i = 0; i < this.selectedStaff.length; i++) {
                    if(this.selectedStaff[i].user_id == staff.user_id) {
                        return i;
                    }
                }
            }
            return -1;
        },
        selectStaff(staff) {
            if(staff) {
                let staff_index = this.getSelectedStaffIndex(staff);
                if(staff_index == -1) {
                    this.selectedStaff.push(staff);
                } else {
                    this.selectedStaff.splice(staff_index, 1);
                }
            }
        },
        getStaffListToUpdate() {
            let result = '';
            if(this.selectedStaff && this.selectedStaff.length > 0) {
                for(let i = 0; i < this.selectedStaff.length; i++){
                    if(i == 0) {
                        result += this.selectedStaff[i].user_id;
                    } else {
                        result += (',' + this.selectedStaff[i].user_id);
                    }
                }
            }
            return result;
        },
        updateStaff() {
            if(this.popupUpdateStaffConfig && this.popupUpdateStaffConfig.item_info) {
                let obj = {
                    checkin_id: this.popupUpdateStaffConfig.item_info.id,
                    list_staff: this.getStaffListToUpdate()
                }
                this.$emit('UpdateCustomerCheckinStaff', obj);
            }
        }
    },
    computed: {
        staffListWithSearch() {
            return this.$store.getters['staffList/staffListWithSearch'](this.search);
        },
    }
}
</script>

<style lang="scss">
.con-vs-popup {
    &.checkout-update-staff-popup {
        z-index: 90000 !important;
        .vs-popup {
            width: calc(100% - 80px);
            height: auto;
            .vs-popup--content {
                width: auto;
                // height: calc(100vh - 200px);
                height: 100vh;
                // padding: 0;
                position: relative;

                // max-height: calc(100vh - 200px);
                // min-height: calc(100vh - 600px);
                margin: 0 !important;
                .popup-staff-col {
                    width: calc(100% / 3) !important;
                }
                @media (max-width: 900px) {
                    .popup-staff-col {
                        width: 50% !important;
                    }
                }

                @media (max-width: 600px) {
                    .popup-staff-col {
                        width: 100% !important;
                    }
                }
            }
        }
    }
}
</style>